import React from "react";
import { useDispatch } from "react-redux";

import { Skeleton, Button } from "components";
import useLoader from "hooks/useLoader";
import { uiActions } from "store";

import DefaultLogo from "static/images/default_logo.png";
import { ReactComponent as RemoveIcon } from "static/images/cancel.svg";
import { ReactComponent as EditIcon } from "static/images/pencil.svg";
import styles from "./uploadLogoMerchant.module.scss";

export const UploadLogoMerchant = ({
	logoPath,
	deleteLogo,
	handleAttachLogo,
	loading = false,
}) => {
	const dispatch = useDispatch();

	const Loader = useLoader(loading);

	const showLogoModal = () => {
		dispatch(
			uiActions.showModal("ADD_LOGO", {
				handleSubmit: handleAttachLogo,
			}),
		);
	};

	return (
		<div className={styles.wrapperLogo}>
			<div className={styles.wrappLogo}>
				<Loader
					skeleton={<Skeleton height={130} width={140} />}
					component={
						<img
							className={styles.logo}
							src={logoPath || DefaultLogo}
							alt="Merchant Logo"
							onError={e => {
								e.target.onerror = null;
								e.target.src = DefaultLogo;
							}}
							onClick={showLogoModal}
						/>
					}
				/>

				<p className={styles.sign}>
					Ideal Width: 384px
					<br />
					formats: .png, .jpg, .jpeg
				</p>
				<div className={styles.wrappBtnAddLogo}>
					<div className={styles.wrappRemoveIcon}>
						<Button
							btnIcon
							icon={<RemoveIcon />}
							onClick={() => {
								deleteLogo({
									statusRequest: logoPath?.statusText,
								});
							}}
							className={styles.removeIcon}
							variant="secondary"
							size="sm"
							title="Remove"
						/>
					</div>
					<div className={styles.wrappEditIcon}>
						<Button
							btnIcon
							icon={<EditIcon />}
							onClick={showLogoModal}
							className={styles.editIcon}
							variant="secondary"
							size="sm"
							title="Edit"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
